module.exports = __webpack_public_path__ + "img/page_3_4.2d831bfd.png";